var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.cookies_accepted)?_c('div',{staticClass:"cookie-notice"},[_c('div',{staticClass:"cookie-notice-text"},[_vm._v(" "+_vm._s(_vm.$t('cookie info'))+" ")]),_c('div',{staticClass:"cookie-notice-action",on:{"click":_vm.accept}},[_vm._v(" "+_vm._s(_vm.$t('ok'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }